<script>
/**
 * ****************************************************************************
 * @description     :   Table Component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
// import { defineComponent } from 'vue';
import { HotTable } from '@handsontable/vue3';
import { registerAllModules } from 'handsontable/registry';
// import the `NumericCellType` module and the `registerCellType()` function
import { registerCellType, NumericCellType } from 'handsontable/cellTypes';
// import the `UndoRedo` module and the `registerPlugin()` function
import { registerPlugin, UndoRedo } from 'handsontable/plugins';
// register Handsontable's modules
registerAllModules();
// register the `NumericCellType` module
registerCellType(NumericCellType);
// register the `UndoRedo` module
registerPlugin(UndoRedo);

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of handsontable component
 */

var AnsTable = {
    template: template,
    props: {
        id: String,
        label: String,
        data: Array,
        nestedHeaders: Array,
        colWidths: Array,
        fixedColumnsLeft: Number,
        height: Number,
        rowHeights: Number,
        columns: Array,
        mergeCells: Array,
        manualRowResize: Boolean,
        manualColumnResize: Boolean,
        manualColumnMove: Boolean,
        RowHeaders: Boolean,
        width: String,
        contextMenu: Object,
        firstRowRenderer: Function,
        negativeValueRenderer: Function,
        cells: Function
    },
    data() {
        return {
            hotData: null,
            hotSettings: {
                data: this.data,
                nestedHeaders: this.nestedHeaders,
                RowHeaders: this.RowHeaders,
                rowHeights: this.rowHeights,
                manualRowResize: this.manualRowResize,
                manualColumnResize: this.manualColumnResize,
                width: this.width,
                height: this.height,
                fixedColumnsLeft: this.fixedColumnsLeft,
                colWidths: this.colWidths,
                contextMenu: this.contextMenu,
                columns: this.columns,
                manualColumnMove: this.manualColumnMove,
                cells: this.cells,
                mergeCells: this.mergeCells,
                licenseKey: 'non-commercial-and-evaluation'
            }
        };
    },
    mounted() {
        this.hotSettings.data = this.data;
        this.hotSettings.nestedHeaders = this.nestedHeaders;
        this.hotSettings.RowHeaders = this.RowHeaders;
        this.hotSettings.colWidths = this.colWidths;
        this.hotSettings.fixedColumnsLeft = this.fixedColumnsLeft;
        this.hotSettings.height = this.height;
        this.hotSettings.rowHeights = this.rowHeights;
        this.hotSettings.columns = this.columns;
        this.hotSettings.manualRowResize = this.manualRowResize;
        this.hotSettings.manualColumnResize = this.manualColumnResize;
        this.hotSettings.manualColumnMove = this.manualColumnMove;
        this.hotSettings.RowHeaders = this.RowHeaders;
        this.hotSettings.width = this.width;
        this.hotSettings.contextMenu = this.contextMenu;
        this.hotSettings.mergeCells = this.mergeCells;
    },
    components: {
        HotTable
    }
};
export default AnsTable;
</script>
